// querySuggestionsInCategoryPlugin.tsx
// Provides an Algolia Autocomplete plugin for category-based query suggestions.
// Integrates with Algolia to fetch and display query suggestions filtered by category.

import React, { Fragment } from 'react';
import { createQuerySuggestionsPlugin } from '@algolia/autocomplete-plugin-query-suggestions';
import { INSTANT_SEARCH_HIERARCHICAL_ATTRIBUTES } from '../../context/constants';

interface SetInstantSearchUiStateOptions {
  query: string;
  category?: string;
}

export function createQuerySuggestionsInCategoryPlugin({
  searchClient,
  indexName,
  currentCategory,
  setInstantSearchUiState,
}: {
  searchClient: any;
  indexName: string;
  currentCategory: string | undefined;
  setInstantSearchUiState: (options: SetInstantSearchUiStateOptions) => void;
}) {
  return createQuerySuggestionsPlugin({
    searchClient,
    indexName,
    getSearchParams() {
      return {
        hitsPerPage: 3,
        facetFilters: [
          `${indexName}.facets.exact_matches.${INSTANT_SEARCH_HIERARCHICAL_ATTRIBUTES?.[0]}:${currentCategory}`,
        ],
      };
    },
    transformSource({ source }) {
      return {
        ...source,
        sourceId: 'querySuggestionsInCategoryPlugin',
        onSelect({ item }) {
          setInstantSearchUiState({
            query: item?.query,
            category: item?.__autocomplete_qsCategory,
          });
        },
        getItems(params) {
          if (!currentCategory) {
            return [];
          }
          return source?.getItems(params);
        },
        templates: {
          ...source?.templates,
          header({ items }) {
            if (items?.length === 0) {
              return <Fragment />;
            }
            return (
              <Fragment>
                <span className="aa-SourceHeaderTitle">In {currentCategory}</span>
                <span className="aa-SourceHeaderLine" />
              </Fragment>
            );
          },
          item({ item, components }) {
            return (
              <Fragment>
                <components.Highlight hit={item} attribute="query" />
              </Fragment>
            );
          },
        },
      };
    },
  });
}
